import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTabGroup } from "@angular/material/tabs";
import { AbstractBuyerComponent } from "./abstract/buyer.component";
import { environment } from "../../environments/environment";
import { Pair } from "../obj/Pair";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { BuyOffer } from "../entity/BuyOffer";
import { ConfirmationDialog } from "./incs/confirmation-dialog.component";
import { HeaderComponent } from "./incs/header.component";
import { BuyOfferEditComponent } from "./incs/buy-offer-edit.component";

@Component({
    selector: "kilowant-buy-order-add",
    templateUrl: "../../html/main-buy-order-add.html",
    imports: [HeaderComponent, BuyOfferEditComponent]
})
export class BuyOfferAddComponent extends AbstractBuyerComponent {

    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
       this.analyticsService.trackEvent("Buy Order Add Page", "User Opens Buy Order Add Page", "OPEN_PAGE");
    }

    ngAfterViewInit(): void {
    }

    finish(): void {
       this.router.navigate(["/buy-offer/list"]);
    }

    cancel(): void {
      this.router.navigate(["/buy-offer/list"]);
    }

}